export const showOverlay = (overlay) => ({
    type: 'SHOW_OVERLAY',
    overlay,
});

export const hideOverlay = () => ({
    type: 'HIDE_OVERLAY',
});
